
    import { defineComponent, PropType, ref } from 'vue'

    import { Post } from '@/common/models/data/dashboard/posts/post'
    import { PostSocialLinks } from '@/common/models/data/dashboard/posts/post-social-links'

    import PostSocialButtons from '@/app/components/common/posts/PostSocialButtons.vue'

    export default defineComponent({
        components: {
            PostSocialButtons
        },

        props: {
            post: {
                type: Object as PropType<Post>,
                required: true
            },
            shares: {
                type: Object as PropType<PostSocialLinks>,
                required: true
            }
        },

        setup () {
            const tagsShown = ref(false)
            const showTags = (): void => {
                tagsShown.value = true
            }

            return {
                showTags,
                tagsShown
            }
        }
    })
